import { render } from "./HeaderTabletFormComponent.vue?vue&type=template&id=21651c5b"
import script from "./HeaderTabletFormComponent.vue?vue&type=script&lang=js"
export * from "./HeaderTabletFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__